export default __webpack_public_path__ + "static/media/closet5-after3-480w.7910e16f.webp";